import { api } from '@api/api2';

export const getTicketStatuses = () => api.v1('get', 'tck/statuses/list');
